import React from 'react';
import styles from "../../../styles/security/SecProduct.module.css";

import SecResearchIntro from '../../../components/security/research/SecResearchIntro';
import SecResearchFocus from '../../../components/security/research/SecResearchFocus';
import SecResearchWhyCards from '../../../components/security/research/SecResearchWhyCards';

const SecResearch = () => {
  return (
    <main className={styles.container}>
      <SecResearchIntro styles={styles} />
      <SecResearchFocus styles={styles} />
      <SecResearchWhyCards styles={styles} />
    </main>
  )
}

export default SecResearch